import React, { useEffect, useState } from 'react';
import axios from 'axios';

const TextFetcher = ({ saochep, url }) => {
  const [textData, setTextData] = useState('');

  useEffect(() => {
    // Gọi API để lấy dữ liệu từ file txt bằng axios
    axios.get(url)
      .then((response) => {
        setTextData(response.data);
      })
      .catch((error) => {
        console.error('Error fetching the text file:', error);
      });
  }, [url]);

  return (
    <>
      <div className="text-sm text-center">
        {textData ? (
          <div className="break-all text-xs">{textData}</div>
        ) : (
          <div>Loading...</div>
        )}
        <button
          onClick={() => saochep(textData)} className="bg-blue-500 hover:bg-blue-700 text-white text-xs font-bold py-1 px-2 mt-1 rounded"
        >
          sao chép
        </button>
      </div>
    </>
  );
};

export default TextFetcher;
